import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { BodyTextMedium } from 'Packages/FacetDesign/Components/BodyText';
import { FDDialogTitle } from '@facet-wealth/design';

const SuccessStepMetaOverrideSet = buildFacetDesignOverride()
  .nameOverride('title', {
    _component: () => FDDialogTitle,
  }, overrideReadOnly)
  .nameOverride('primaryText', {
    _component: () => BodyTextMedium,
  }, overrideReadOnly);

export default SuccessStepMetaOverrideSet;
